/* eslint-disable object-property-newline */
/* eslint-disable import/no-cycle  */
import { MessageTypes, MessageSubtypes } from './constants';
import { FileMessage, TextMessage, MessageParams } from './models';

export const regLink = /(?:(?:https?|ftp|ftps|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#/%=~_|$?!:,.]*\)|[A-Z0-9+&@#/%=~_|$])/gi;

export const createMessage = ({
  id, nickname, text, date, type, subtype, clientTimestamp, isFake, parentClientTimestamp, lastEditedTime,
  translatedTextHtml, modCount, additionalState, visitorServerUrl, domain, url,
  description, title, image, authorId, textDisplayTemplate,
}) => {
  if (subtype === MessageSubtypes.PREVIEW) {
    return {
      id, nickname, text, date, type, subtype, clientTimestamp, isFake, domain,
      url, description, title, image, additionalState, visitorServerUrl, parentClientTimestamp,
    };
  }

  const messageParams = new MessageParams({
    id, nickname, text, date, type, subtype, clientTimestamp, visitorServerUrl,
    isFake, additionalState, authorId, lastEditedTime, translatedTextHtml, modCount, textDisplayTemplate,
  });

  if (subtype === MessageSubtypes.FILE) {
    return new FileMessage(messageParams, messageParams.visitorServerUrl);
  }

  return new TextMessage(messageParams, messageParams.visitorServerUrl);
};

export const addMessage = (newMessage, messages) => {
  const { isAlreadyExists, isShouldReplaceExisting, index } = parseMessagesRegardingNewMessage(newMessage, messages);
  // eslint-disable-next-line max-len
  // console.warn('isExists=', isAlreadyExists + 0, 'replace=', isShouldReplaceExisting + 0, 'ii=', index, 'p=', JSON.stringify(newMessage))
  if (isAlreadyExists) return messages

  const newMessages = messages.slice();
  newMessages.splice(index, +isShouldReplaceExisting, newMessage);
  return newMessages
}

export const deleteMessage = ({ messages, messageId }) => {
  const newMessages = messages.slice();
  for (let ii = newMessages.length; ii--;) {
    if (newMessages[ii].id === messageId) {
      newMessages.splice(ii, 1);
      return newMessages
    }
  }
  return newMessages
}

export const updateMessage = ({
  messages, messageId, modCount, lastEditedTime, originalTextHtml, translatedTextHtml,
}) => {
  const newMessages = messages.slice();
  for (let ii = newMessages.length; ii--;) {
    if (newMessages[ii].id === messageId) {
      newMessages[ii] = createMessage({
        ...newMessages[ii], modCount, lastEditedTime, text: originalTextHtml, translatedTextHtml,
      })
      return newMessages
    }
  }
  return newMessages
}

export const getLatestTalkerMessage = ({ messages, nickname }) => {
  for (let ii = messages.length; ii--;) {
    if (messages[ii].nickname === nickname) {
      return messages[ii]
    }
  }
}

export const numberMessageFromEndAmongVisitorMessages = ({ messages, id, nickname }) => {
  for (let ii = messages.length, number = 0; ii--;) {
    if (messages[ii].nickname === nickname) {
      number++
    }
    if (messages[ii].id === id) {
      return number
    }
  }
}

export function parseMessagesRegardingNewMessage(newMessage, messages) {
  let res = {
    isAlreadyExists: false,
    isShouldReplaceExisting: false,
    index: messages.length,
  };

  /* for link-preview messages should prevent default */
  if (newMessage.subtype === MessageSubtypes.PREVIEW) {
    const parentMessage = messages.find(msg => msg.clientTimestamp === newMessage.parentClientTimestamp);
    const indexOfParentMessage = messages.indexOf(parentMessage);
    res.index = indexOfParentMessage + 1;
    return res
  }

  /* fake message always goes to the end of the list */
  if (newMessage.isFake) {
    return res
  }

  /* main parse by date (message.created from server) */
  for (let ii = messages.length; ii--;) {
    const message = messages[ii];
    if (newMessage.date > message.date) break

    res.index = ii;
    if (newMessage.date === message.date && newMessage.nickname === message.nickname) {
      res.isAlreadyExists = true;
      return res
    }
  }

  const isSystemMessage = newMessage.type === MessageTypes.SYSTEM || newMessage.clientTimestamp === '0'
  if (isSystemMessage) return res

  /* secondary parse by client timestamp, between messages from the same user nearby */
  for (let ii = messages.length; ii--;) {
    const message = messages[ii];
    if (newMessage.nickname !== message.nickname) continue
    // if (message.clientTimestamp === '0') continue /* is message from start chat form */
    if (newMessage.clientTimestamp > message.clientTimestamp) return res

    res.index = ii;
    if (newMessage.clientTimestamp === message.clientTimestamp) {
      if (message.isFake || newMessage.text !== message.text) {
        res.isShouldReplaceExisting = true;
      } else {
        res.isAlreadyExists = true;
      }
      return res
    }
  }

  return res
}

export function tryChangeVisitorNicknameToNicknameWithNumber(messages, currentNickName, newNickName) {
  if (currentNickName === newNickName) return messages
  return messages.map(message => {
    if (message.nickname !== currentNickName) return message
    return {
      ...message,
      nickname: newNickName,
    }
  });
}
